import * as React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const FilesPdfColoredIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg role="presentation" focusable="false" viewBox="0 0 20 20" className={classes.svg}>
      <path d="M16 7H13.5C12.673 7 12 6.327 12 5.5V2H4V18H16V7Z" fill="white" />
      <path d="M16 6.00003V5.70703L13 2.70703V5.50003C13 5.77503 13.225 6.00003 13.5 6.00003H16Z" fill="white" />
      <path
        opacity="0.64"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.707 5L13 1.293C12.8125 1.10545 12.5582 1.00006 12.293 1H4C3.44772 1 3 1.44772 3 2V18C3 18.5523 3.44772 19 4 19H16C16.5523 19 17 18.5523 17 18V5.707C16.9999 5.4418 16.8945 5.18749 16.707 5ZM16 5.707V6H13.5C13.2241 5.99945 13.0006 5.77591 13 5.5V2.707L16 5.707ZM4 2.2V17.8C4 17.9105 4.08954 18 4.2 18H15.8C15.9105 18 16 17.9105 16 17.8V7H13.5C12.6716 7 12 6.32843 12 5.5V2H4.2C4.09 2 4 2.09 4 2.2Z"
        fill="#605E5C"
      />
      <path
        d="M14.5 10H5.5C5.22386 10 5 9.77614 5 9.5C5 9.22386 5.22386 9 5.5 9H14.5C14.7761 9 15 9.22386 15 9.5C15 9.77614 14.7761 10 14.5 10Z"
        fill="#C8C6C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 16V12C6 11.4477 6.44772 11 7 11H13C13.5523 11 14 11.4477 14 12V16C14 16.5523 13.5523 17 13 17H7C6.44772 17 6 16.5523 6 16ZM7.2 16H12.794C12.8468 16.0016 12.898 15.9816 12.9358 15.9447C12.9735 15.9077 12.9946 15.8569 12.994 15.804C12.988 15.126 12.996 12.872 13 12.194C13 12.084 12.91 12 12.8 12H7.2C7.09 12 7 12.09 7 12.2V15.8C7 15.9105 7.08954 16 7.2 16ZM4.75 16H3C2.44772 16 2 15.5523 2 15V13C2 12.4477 2.44772 12 3 12H4.75C4.88807 12 5 12.1119 5 12.25V15.75C5 15.8881 4.88807 16 4.75 16ZM15.25 16H17C17.5523 16 18 15.5523 18 15V13C18 12.4477 17.5523 12 17 12H15.25C15.1119 12 15 12.1119 15 12.25V15.75C15 15.8881 15.1119 16 15.25 16Z"
        fill="#D65532"
      />
    </svg>
  ),
  displayName: 'FilesPdfColoredIcon',
});
